export class BufferCalculationType {
  static pKa = new BufferCalculationType(1, 'pKa');
  static Interpolate = new BufferCalculationType(2, 'Interpolate');

  get ID() {
    return this.id;
  }

  get Name() {
    return this.Name;
  }

  constructor(id, name) {
    this.id = id;
    this.name = name;
  }

  GetBufferCalculationType() {
    return null;
  }
}
